import type { HTMLAttributes } from 'react';
import { clsx } from '../clsx';
import styles from './Pill.module.css';

export type PillVariant = 'success' | 'warning' | 'danger' | 'info' | 'accent' | 'neutral';

export interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: PillVariant | undefined;
  /** `default` is the status pill of lists and records (3/9, 11 px); `large` the connection state pill of the settings (5/10). */
  size?: 'default' | 'large' | undefined;
  /** Leading 6 px dot in the variant's foreground colour (connection and auto-save pills). */
  dot?: boolean | undefined;
}

/** Status pill: "Kunde", "Call gebucht", "Follow Up", "Neu", "Nicht erreicht", "Reserviert", "System". */
export function Pill({
  variant = 'neutral',
  size = 'default',
  dot = false,
  className,
  children,
  ...rest
}: PillProps) {
  return (
    <span
      className={clsx(styles.pill, styles[variant], size === 'large' && styles.large, className)}
      {...rest}
    >
      {dot ? <span aria-hidden="true" className={styles.dot} /> : null}
      {children}
    </span>
  );
}
